import { utils } from '@deeptrue-frontend/ui';
import React from 'react';
import {
  localization,
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from 'survey-react-ui';

import { ElementFactory, Question, Serializer, SvgRegistry } from 'survey-core';
import { ReactComponent as WidgetIcon } from 'assets/icons/widget.svg';
import ReactDOMServer from 'react-dom/server';

const registerBrandSelector = () => {
  // @ts-ignore
  const BrandSelector = utils.survey.widgets.BrandSelector.widget;

  // create model for new question type
  class QuestionBrandselectorModel extends Question {
    getType() {
      return 'dtbrandselector';
    }
    get brandSelectorType() {
      return this.getPropertyValue('brandselectorType');
    }
    set brandSelectorType(val) {
      this.setPropertyValue('brandselectorType', val);
    }
  }

  // set display title for question type
  localization.getLocale('').qt.dtbrandselector = 'dt Brand Selector';

  const svg = ReactDOMServer.renderToString(<WidgetIcon />);
  SvgRegistry.registerIconFromSvg('dtbrandselector', svg);

  // this serializes the class into JSON
  Serializer.addClass(
    'dtbrandselector',
    [
      {
        name: 'brandselectorType',
      },
    ],
    function () {
      return new QuestionBrandselectorModel('');
    },
    'question'
  );

  Serializer.addProperties('dtbrandselector', [
    {
      name: 'placeholderBrand',
      category: 'Locales',
      isLocalizable: true,
      default: 'Select brand',
    },
    {
      name: 'placeholderSearchBrand',
      category: 'Locales',
      isLocalizable: true,
      default: 'Search brand...',
    },
    {
      name: 'isMultiselect:switch',
      category: 'Brands',
    },
  ]);

  SurveyQuestionEditorDefinition.definition.brandselector = {
    properties: [{ name: 'brandselectorType', tab: 'layout' }],
  };

  ElementFactory.Instance.registerElement('dtbrandselector', (name) => {
    return new QuestionBrandselectorModel(name);
  });

  class SurveyQuestionBrandselector extends SurveyQuestionElementBase {
    constructor(props: any) {
      super(props);
      this.state = { value: this.question.value };
    }
    get question() {
      return this.questionBase;
    }
    get value() {
      return this.question.value;
    }

    get type() {
      // @ts-ignore
      return this.question.brandselectorType;
    }
    handleBrandselectorChange = (data: any) => {
      this.question.value = data;
    };

    // support readOnly and designMode
    get style() {
      return this.question.getPropertyValue('readOnly') ||
        this.question.isDesignMode
        ? {
            pointerEvents: 'none',
          }
        : undefined;
    }

    renderElement() {
      return (
        // @ts-ignore
        <BrandSelector question={this.question} />
      );
    }
  }
  ReactQuestionFactory.Instance.registerQuestion(
    'dtbrandselector',
    (props: any) => {
      return React.createElement(SurveyQuestionBrandselector, props);
    }
  );

  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'dtbrandselector';
    },
    getJSON: function () {
      return { type: 'dtbrandselector' };
    },
  });
};

export default registerBrandSelector;
